<template>
  <div class="labs-index">
    <div class="ui container">

      <div class="ui breadcrumb" style="margin: 20px 0 10px 0;">
        <router-link to="/" class="section">Home</router-link>
        <i class="right chevron icon divider"></i>
        <div class="active section">Labs</div>
      </div>

      <h1 class="ui header" style="margin-bottom: 30px;">
        <i class="flask icon"></i>
        <div class="content">
          JC Steele Labs
          <div class="sub header">Laboratory testing data for your materials and extrusions</div>
        </div>
      </h1>

      <div class="ui four stackable cards">

        <div class="card" @click="$router.push('/labs/mixes')" style="cursor:pointer;">
          <div class="content">
            <div class="header">
              <i class="tint icon"></i> Mixes
            </div>
            <div class="description">
              View mix records including material formulations, water-by-mass targets, and mix conditions.
            </div>
          </div>
          <div class="extra content">
            <router-link to="/labs/mixes" class="ui primary button fluid">
              {{ isAdmin ? 'Edit' : 'View' }} Mixes <i class="right arrow icon"></i>
            </router-link>
          </div>
        </div>

        <div class="card" @click="$router.push('/labs/extrusions')" style="cursor:pointer;">
          <div class="content">
            <div class="header">
              <i class="industry icon"></i> Extrusions
            </div>
            <div class="description">
              Review extrusion test results including die settings, auger data, pressure, and throughput.
            </div>
          </div>
          <div class="extra content">
            <router-link to="/labs/extrusions" class="ui primary button fluid">
              {{ isAdmin ? 'Edit' : 'View' }} Extrusions <i class="right arrow icon"></i>
            </router-link>
          </div>
        </div>

        <div class="card" @click="$router.push('/labs/specimens')" style="cursor:pointer;">
          <div class="content">
            <div class="header">
              <i class="chart bar icon"></i> Specimens
            </div>
            <div class="description">
              Access specimen strength and durability test results including compression, tensile, and tumble index.
            </div>
          </div>
          <div class="extra content">
            <router-link to="/labs/specimens" class="ui primary button fluid">
              {{ isAdmin ? 'Edit' : 'View' }} Specimens <i class="right arrow icon"></i>
            </router-link>
          </div>
        </div>

        <div class="card" @click="$router.push('/labs/raw-materials')" style="cursor:pointer;">
          <div class="content">
            <div class="header">
              <i class="boxes icon"></i> Raw Materials
            </div>
            <div class="description">
              Browse raw material inventory including particle size distribution and moisture content data.
            </div>
          </div>
          <div class="extra content">
            <router-link to="/labs/raw-materials" class="ui primary button fluid">
              {{ isAdmin ? 'Edit' : 'View' }} Raw Materials <i class="right arrow icon"></i>
            </router-link>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LabsIndex",
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    isAdmin() {
      return this.currentUser && this.currentUser.admin;
    },
  },
};
</script>
